// @flow
import * as React from 'react';
import Hide from 'components/Hide';
import { bp } from '../theme';

const breakpointNames = ['xs', 'sm', 'md', 'lg', 'xl'];

const HideContainer = ({
  children,
  xs,
  sm,
  md,
  lg,
  xl,
  mobile,
  desktop,
  noWrapper,
  ...props
}: {
  children: React.Node,
  xs?: boolean,
  sm?: boolean,
  md?: boolean,
  lg?: boolean,
  xl?: boolean,
  mobile?: boolean,
  desktop?: boolean,
  noWrapper?: boolean
}) => {
  const { useState, useEffect } = React;
  const [breakpoint, setBreakpoint] = useState(0);
  const hide = {
    xs: xs || mobile || false,
    sm: sm || mobile || false,
    md: md || mobile || false,
    lg: lg || desktop || false,
    xl: xl || desktop || false
  };

  const resizeHandler = () => {
    const width = window.innerWidth;
    const newBreakpoint = bp.reduce(
      (current, point, index) => (width >= point ? index + 1 : current),
      0
    );
    setBreakpoint(newBreakpoint);
  };

  useEffect(() => {
    resizeHandler();
    window.addEventListener('resize', resizeHandler);

    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  });

  return noWrapper ? (
    typeof window === 'undefined' ||
    hide[breakpointNames[breakpoint]] ? null : (
      children
    )
  ) : (
    <Hide
      xs={xs || mobile}
      sm={sm || mobile}
      md={md || mobile}
      lg={lg || desktop}
      xl={xl || desktop}
      {...props}
    >
      {children}
    </Hide>
  );
};

export default HideContainer;
